module.exports = __webpack_public_path__ + "static/media/smiley.7cbb65bd.png";